import { defineComponent as _defineComponent } from 'vue'
import BannerX from './BannerX.vue';
import { CatalogState } from 'JS/catalog/store/store';
import { computed } from 'vue';
import { IBannerXAd } from '../sponsored-types';
import { useLegacyVuexStore } from 'JS/composables/legacy-vuex-store';


export default /*#__PURE__*/_defineComponent({
  __name: 'BannerXApp',
  setup(__props) {

const store = useLegacyVuexStore<CatalogState>();

const pageNum = computed<number>(() => {
	return store.state.searchResult.pageNum;
});

const bannerX = computed<IBannerXAd>(() => {
	return store.state.epsilonAds.bannerXAdTop;
});


return { __sfc: true,store, pageNum, bannerX, BannerX }
}

})